import { useCallback } from "react";
import CultureResources from "utilities/interfaces/culture-resources";
import { t } from "utilities/localization-utils";
import { ToastManager } from "utilities/toast/toast-manager";

const usePageBlockError = () => {
    const showError = (
        action: keyof CultureResources,
        resource: keyof CultureResources
    ) => {
        ToastManager.error(t("errors-actionResource", { action, resource }));
    };

    return {
        showError: useCallback(showError, []),
    };
};

export default usePageBlockError;
